import React, { memo } from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  dateSeparator: {
    display: "flex",
    justifyContent: "center",
    margin: "16px 0",
    width: "100%",
  },
  dateSeparatorLabel: {
    background: theme.mode === "light" ? "rgba(255, 255, 255, 0.92)" : "#202c33",
    color: theme.mode === "light" ? "#54656f" : "#d1d7db",
    fontSize: 12,
    padding: "6px 12px",
    borderRadius: 8,
    boxShadow: "0 1px 1px rgba(0,0,0,0.08)",
    fontWeight: 500,
  },
}));

const DateSeparator = ({ label }) => {
  const classes = useStyles();

  return (
    <div className={classes.dateSeparator}>
      <div className={classes.dateSeparatorLabel}>{label}</div>
    </div>
  );
};

export default memo(DateSeparator);
